// The Auth email link arrives as a fragment, which the browser does not send to
// the server. Keep it only in module memory and remove it before the app imports
// Auth, analytics, or any component that could observe the current URL.
let pendingTokenHash: string | null = null;

interface ActivationLocation {
  pathname: string;
  search: string;
  hash: string;
}

interface ActivationHistory {
  state: unknown;
  replaceState: (data: unknown, unused: string, url?: string | URL | null) => void;
}

export function captureBatch1ActivationToken(
  location: ActivationLocation = window.location,
  history: ActivationHistory = window.history,
): void {
  if (location.pathname !== "/b1/activate") return;
  const match = /^#token_hash=([a-f0-9]{56})$/.exec(location.hash);
  pendingTokenHash = match?.[1] ?? null;
  if (location.hash) history.replaceState(history.state, "", `${location.pathname}${location.search}`);
}

export function consumeBatch1ActivationToken(): string | null {
  const token = pendingTokenHash;
  pendingTokenHash = null;
  return token;
}
